import React from 'react';
import { Link } from 'react-router-dom';

const WhatsapWiget = () => {
  return (
    <div className='fixed bottom-1 left-0 flex flex-col items-center p-4 z-50'>
        
        {/* WhatsApp */}
        <div className='relative transition-transform transform hover:scale-110'>
            <Link to="https://wa.me/9254147455" target="_blank">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#25D366] shadow-lg hover:shadow-xl transition-all duration-300">
                    <i className="fa-brands fa-whatsapp fa-2x text-white"></i>
                </div>
            </Link>
        </div>
    </div>
  );
};

export default WhatsapWiget;
